module.exports = __webpack_public_path__ + "img/08.a1a9b602.png";